export const pageTitle = (title) => {
  return ( document.title = title + " - Creative Agency");
}

// Prefixes a public-folder image path with PUBLIC_URL so asset paths resolve
// correctly on sub-path deployments (e.g. /alpha/images/foo.jpg on staging).
export const imgUrl = (path) => {
  // CRA strips trailing slash from PUBLIC_URL at build time (e.g. /alpha/ → /alpha)
  // so we normalise: remove trailing slash from base, ensure leading slash on path
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${cleanPath}`;
};